
export default {
  props: {
    modalType: {
      default: 0
    },
  },
  data() {
    return {
      showPass: false,
      form: {
        email: null,
        phone: null,
        isWhatsappNoSame: true,
        waphone: null,
        name: null,
        username: null
      },
      //Form error variables
      errors: {
        formError: null,
        formErrMsg: "Opps! Something went wrong, please try again."
      },
      // Form submit variables
      submit: {
        loading: false,
        success: false,
        errored: false
      },
      modalText: {
        title: 'Booking Details',
        name: 'Your name :',
        email: 'Your tickets will be mailed to :',
        phone: 'You will be contacted on :',
        button: 'Book Now',
      }
    }
  },

  mounted() {
    this.setModalTitles()
  },

  methods: {
    setModalTitles() {
      switch (this.modalType) {
        case 1:
        case "1":
          this.modalText.title = 'Unlock Offers';
          this.modalText.name = 'Your Name';
          this.modalText.email = 'Your Email';
          this.modalText.phone = 'Your Phone';
          this.modalText.button = 'Unlock Now';
          break;
        default:
        // code block
      }
    },
    string_to_slug(str, phoneNumber) {
      str = str.replace(/^\s+|\s+$/g, ''); // trim
      str = str.toLowerCase();

      // remove accents, swap ñ for n, etc
      var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaaeeeeiiiioooouuuunc------";

      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

      var number = phoneNumber.replace(/\D/g, '').slice(-10);

      return str + '-' + number;
    },

    isPhoneSame(isSame) {
      if (isSame) {
        this.form.waphone = this.form.phone;
      } else {
        this.form.waphone = '';
      }
    },

    isPhoneChange(isSame) {
      if (isSame) {
        this.form.waphone = this.form.phone;
      }
    },

    // To clear the submit error message
    clearFormErrMsg() {
      this.errors.formError = null;
      this.submit.success = false
      this.submit.errored = false
    },
    // Validate and Submit form data to LOGIN
    sendMessage() {
      // Clear all submit errors before API call
      this.errors.formError = null;
      this.submit.success = false
      this.submit.errored = false
      // Validate all fields for making the API call, throw error and not call API if validation errors are present
      this.$refs.registrationForm.validate().then((success) => {
        if (!success) {
          // run your error code here
          this.errors.formError = "One or more incorrect fields present, please fix.";
        } else {
          // If Valid form
          // Create url encoded formData instance to pass the data to the API
          var formData = new URLSearchParams();
          formData.append("phone", this.form.phone.trim());
          formData.append("waNumber", this.form.waphone.trim());
          formData.append("email", this.form.email.trim());
          formData.append("username", this.form.name.trim());
          formData.append("slug", this.string_to_slug(this.form.name.trim().toLowerCase(), this.form.phone.trim()));
          // Add header for the API
          const headers = {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
          this.submit.loading = true;
          // AXIOS api call to add SIGNIN api
          this.$axios
            .post("/api/users/app/createFreshUser", formData, {
              headers: headers
            })
            .then(response => {
              this.submit.success = true
              this.submit.errored = false
              let value = this.getCryptKey(response.data);
              localStorage.setItem("authToken", "bearer " + value.token);
              this.$store.commit('login', value.token);
              this.myProfile(value.token);

            })
            .catch(error => {
              if (error.response)
                this.errors.formErrMsg = this.getCryptKey(error.response.data)
              this.submit.success = false
              this.submit.errored = true
            })
            .finally(() => {
              this.submit.loading = false
            });
        }
      });
    },
    myProfile(token) {
      // Add header for the API
      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': "bearer " + token,
      }
      // AXIOS api call to add SIGNIN api
      this.$axios
        .get("/api/users/me/", {
          headers: headers
        })
        .then(response => {
          // New flow
          let value = this.getCryptKey(response.data);
          localStorage.setItem("profile", JSON.stringify(value));
          this.$store.commit('profile', value.username);
          console.log("here")
          this.$bvModal.hide('checkout')
          this.$emit("userCreated", true);
        })
        .catch(error => { });
    },
  }
}

